import { Pages, NavigationFunction as RootNavigation } from "../Navigation/root"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import "../Translations/index"
import { css, icons } from "../Styles/index"
import { ListStyle_Types } from "../Definitions"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { setStates } from "../Store/StateHandlers/active-slice"
import { NewButtonList } from "../Components/BaseComponents/Buttons/newButton"


export default function Def() {
  const navigator = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setStates({ type: "farm", farm: undefined }));
  }, []);
  
  const BtnFunc_Router = (btn_index: number) => {
    switch (btn_index) {
      case 0: 
        RootNavigation({ Navigator: navigator, navigation_page: Pages.kpi })
        break
      case 1:
        RootNavigation({ Navigator: navigator, navigation_page: Pages.op_operations })
        break
      default:
        alert("Error ???")
    }
  }

  return (
    <div>
      <NewButtonList 
        contents={[t("loginFlow.def.fullView", {defaultValue: "full view"}), t("loginFlow.def.focus_view", {defaultValue: "focus view"})]}
        onClick={(e) => BtnFunc_Router(e)}
        startEnhancers={[icons.platformDesktop, icons.platformOperation]}
        listOverrides={{
          listStyle: ListStyle_Types.vertical
        }}
      />
    </div>  
  )
} 
